import { Dispatch } from 'react';

import { Button } from '@/components/form/baseInputs/Button';
import { useEstateWaterfallContext } from '@/modules/estateWaterfall/contexts/estateWaterfall.context';

import { EstateWaterfallAction } from '../../../types/actions';
import { createEdgeId } from '../../../waterfallGraph/waterfallGraph';
import { EdgeLabelCard } from '../edgeLabelCard.component';
import { CardConfig } from './types';

function ViewTaxCalculationButton({
  source,
  target,
  dispatch,
}: {
  source: string;
  target: string;
  dispatch: Dispatch<EstateWaterfallAction>;
}) {
  const { state } = useEstateWaterfallContext();

  const edgeId = createEdgeId(source, target);
  const isPresentation = state.presentationMode;

  if (isPresentation) {
    return null;
  }

  return (
    <Button
      sx={{
        width: 'fit-content',
      }}
      variant="primary"
      size="xs"
      onClick={() => {
        dispatch({
          type: 'OPEN_SUMMARY_PANEL',
          nodeId: target,
        });

        // Close the tooltip after opening the panel
        dispatch({ type: 'CLOSE_EDGE_LABEL', edgeId });
      }}
    >
      View tax calculation
    </Button>
  );
}

interface TaxCardParams {
  source: string;
  target: string;
  sourceEntityName: string;
  decedentName?: string;
  label?: string;
  value?: string;
  dispatch: Dispatch<EstateWaterfallAction>;
  isGiftTax: boolean;
}

export function createTaxCard({
  source,
  target,
  sourceEntityName,
  decedentName,
  label,
  value,
  dispatch,
  isGiftTax,
}: TaxCardParams): CardConfig {
  return {
    element: (
      <EdgeLabelCard
        key={target}
        title="Taxes"
        description={
          isGiftTax
            ? `${sourceEntityName} pays gift taxes.`
            : `${sourceEntityName} pays taxes upon ${decedentName}'s death.`
        }
      >
        <ViewTaxCalculationButton
          source={source}
          target={target}
          dispatch={dispatch}
        />
      </EdgeLabelCard>
    ),
    label: label ?? '',
    value: value ?? '',
    variant: 'destructive',
  };
}
